
// 모듈의 순서를 조정 (사이드바 패널만 가능)
export const ARRANGE_ACTIVE_MODULE = "ARRANGE_ACTIVE_MODULE";

// 새로운 모듈을 지정한 위치로 이동
export const MOVE_IN_MODULE = "MOVE_IN_MODULE";

// 모듈을 지정한 위치에서 제거
export const MOVE_OUT_MODULE = "MOVE_OUT_MODULE";

// 해당 인덱스의 모듈 삭제
export const REMOVE_MODULE = "REMOVE_MODULE";

// 데이터 초기화
export const INIT_SIDEBAR = "INIT_SIDEBAR";

// 모듈 정보 업데이트
export const UPDATE_MODULE = "UPDATE_MODULE";
